export enum ContainerType {
    Default,
    AncillaryProduct
}
